<template>
  <div id="configurationName">
    <div v-wave class="configName" v-for="item in configList" :key="item.value" @click="changeConfig(item)">
      <div class="assembly1" :class="[item.status ? 'assembly1Active' : 'assembly1Inertia']" v-show="!item.inputShow">
        <p class="name">{{ item.name }}</p>
        <i class="el-icon-edit-outline" @click.stop="editName(item)"></i>
      </div>
      <div class="assembly1" v-show="item.inputShow">
        <p class="name">
          <el-input v-model="item.name"></el-input>
        </p>
        <i class="el-icon-finished" @click.stop="finishName(item)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import {convertUint8ArrayToChinese} from "@/store/utils";
import EventBus from "@/store/eventBus";

export default {
  name: "configurationName",
  data () {
    return {
      configList: [
        {
          name: 'Config1',
          value: 0,
          status: true,
          inputShow: false
        },
        {
          name: 'Config2',
          value: 1,
          status: false,
          inputShow: false
        },
        {
          name: 'Config3',
          value: 2,
          status: false,
          inputShow: false
        },
        {
          name: 'Config4',
          value: 3,
          status: false,
          inputShow: false
        },
      ],
      temporaryName: ''
    }
  },
  mounted() {
    EventBus.$on('getConfigNameList',this.handleConfigNameList)
    EventBus.$on('returnConfigName',this.handleReturnConfigName)
    EventBus.$on('activeConfig',this.handleActiveConfig)
  },
  methods: {
    editName(obj) {
      this.temporaryName = obj.name
      this.configList.forEach(e => {
        if (obj.value === e.value) {
          e.inputShow = true
        }else {
          e.inputShow = false
        }
      })
    },
    finishName(obj) {
      this.configList.forEach(e => {
        if (obj.value === e.value) {
          if (obj.name.length > 10) {
            this.$notify({
              title: this.$t('警告'),
              message: this.$t('提示内容40'),
              type: 'warning',
              offset: 100
            })
            e.name = this.temporaryName
          } else if (obj.name === '') {
            this.$notify({
              title: this.$t('警告'),
              message: this.$t('提示内容41'),
              type: 'warning',
              offset: 100
            })
            e.name = this.temporaryName
          } else {
            e.inputShow = false
            this.temporaryName = ''
            EventBus.$emit('finishName',e)
          }
        }
      })
    },
    changeConfig(data) {
      if (!data.status && !data.inputShow) {
        this.$confirm(this.$t('提示内容16'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
          type: 'warning'
        }).then(async () => {
         EventBus.$emit('changeConfig',data)
        }).catch(() => {});
      }
    },
    handleActiveConfig(val) {
      this.configList.forEach(e => {
        if (e.value === val) {
          e.status = true
        } else {
          e.status = false
        }
      })
    },
    // 处理得到的配置名称数据
    handleConfigNameList(arr) {
      let uint8Array = new Uint8Array(1)
      for (let i = 0; i < this.configList.length; i++) {
        let filterResult = arr.slice(i*64, i*64+64).filter(x => x !== uint8Array[0])
        if (filterResult && filterResult.length !== 0 && !filterResult.includes(uint8Array[0])) {
          let name = this.configList[i].name
          this.configList[i].name = convertUint8ArrayToChinese(filterResult) ? convertUint8ArrayToChinese(filterResult) : name
        }
      }
    },
    handleReturnConfigName(obj) {
      this.configList.forEach(e => {
        if (obj.value === e.value) {
          e.name = obj.name
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #configurationName {
    width: 100%;
    margin-top: 0.4rem;
    .configName {
      width: 100%;
      height: 0.4rem;
      padding: 0 0.2rem;
      box-sizing: border-box;
      border-radius: 0.01rem;
      margin-bottom: 0.05rem;
      @include font_color('font_color');
      //box-shadow: 0 5px 12px rgba(0,0,0,0.5);
      transition: all 0.3s;
      .assembly1 {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.1rem;
        font-size: 0.2rem;
        @include background_color('background_color_sidebar');
        /deep/.name {
          width: 80%;
          margin-right: 0.1rem;
          .el-input {
            width: 100%;
          }
        }
      }
      .assembly1Active.assembly1 {
        background-color: #409EFF !important;
        @include font_color('font_color_active')
      }
      .assembly1Inertia:hover {
        color: #409EFF;
        background-color: #fff;
        border: 0.02rem solid #409EFF;
      }
    }
  }
</style>
